//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SPage from '~/components/page/SPage.vue'
import LinsesDescription from '~/components/linses/LinsesDescription'
import LinsesTitle from '~/components/linses/LinsesTitle'
import LinsesCompetitorsList from '~/components/linses/main-page/LinsesCompetitorsList'
import LinsesParametrs from '~/components/linses/LinsesParametrs.vue'
import LinsesBenefits from '~/components/linses/LinsesBenefits.vue'
import LinsesOffers from '~/components/linses/LinsesOffers.vue'
import {title} from 'vue-js-modal/docs/.vuepress/config'
import CategoryPage from "~/pages/catalog/_.vue";

export default {
  name: 'competitors',
  components: {
    LinsesOffers,
    LinsesBenefits,
    LinsesParametrs,
    LinsesTitle,
    LinsesCompetitorsList,
    LinsesDescription,
    SPage
  },

  head() {
    const meta = [
      {
        hid: 'metadescription',
        name: 'description',
        content: this?.competitors?.seo_description || '',
      },
    ]

    return {
      title: this?.competitors?.seo_title || this.title || '',
      meta: meta,
    }
  },

  methods: {
    formatPrice(price) {
      if (!price) {
        return '-'
      }

      const formatedPrice = price.replace(/[^0-9.]/g, '')
      return `${this.$numberFormat(formatedPrice)} ₽`
    }
  },
  async asyncData({$api, error, params}) {
    const slug = params?.slug

    const competitors = await $api.agent.transport
      .get(`competitors/competitors-by-slug/${slug}`)
      .then(res => {
        return res.data
      })
      .catch(err => {
        console.log(err.response, 'error')
        error({statusCode: err.response.status})
      })

    return {
      competitors,
    }
  },

  computed: {
    subtitle() {
      return this?.competitors?.subtitle || ''
    },
    linsesOffer() {
      return this.competitors?.reflections || ''
    },
    linsesTypeText() {
      return this.competitors?.lens_type_texts || [];
    },
    title() {
      return `${this?.competitors?.name || ''} от ${this.formatPrice(this?.competitors?.min_price)}` || ''
    },
    recommendations() {
      return this?.competitors?.recommendations || ''
    },
    secondDescription() {
      return this?.competitors?.second_description || ''
    },
    productionTime() {
      return this?.competitors?.production_time || ''
    },
    breadcrumbs() {
      return [{
        title: 'Главная',
        path: '/'
      },
        {
          title: 'Сравнение линз',
          path: '/lenses'
        },
        {
          title: this.competitors?.lenses?.[0]?.title || '',
          path: `/lenses/${this.competitors?.lenses?.[0]?.slug || ''}`
        },
        {
          title: this?.competitors?.name,
          path: this?.competitors?.slug
        }]
    },

    faqBlockValue: function () {
      return {
        useApi: true
      }
    },
  },
}
